export default __webpack_public_path__ + "static/media/360vr.a22cdad1.svg";